import React from 'react';
import { Card, Input, Button, Table, Modal, Form, DatePicker, Spin, Divider,
	message, Tag, Tooltip, Typography, Pagination, Select,
} from 'antd';
import {
	SearchOutlined, PlusOutlined, FormOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, DiffOutlined, RedoOutlined, CalendarOutlined,
	FilterOutlined, SaveOutlined, CloseCircleOutlined, FileTextOutlined,
	EditOutlined, PlusCircleOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title : 'Data Hari Libur',
	apiUrl: { data: 'master/api/hari/libur/' },
	breadCrumb: [
		<span><DiffOutlined /> Pengaturan</span>,
		'Hari Libur',
	],
};

const config = new Config();

const MONTH_COLORS = {
	1: '#1677ff', 2: '#52c41a',  3: '#fa8c16', 4: '#eb2f96',
	5: '#722ed1', 6: '#13c2c2',  7: '#f5222d', 8: '#2f54eb',
	9: '#7cb305', 10: '#fa541c', 11: '#08979c', 12: '#d4380d',
};
const MONTH_NAMES = ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nov','Des'];

function renderTanggalBadge(val, fontSize = 20, size = [52, 56]) {
	if (!val) return <Text type="secondary">—</Text>;
	const [tahun, bulan, hari] = val.split('-');
	const bulanNum = parseInt(bulan);
	const color = MONTH_COLORS[bulanNum] || '#1677ff';
	const bulanName = MONTH_NAMES[bulanNum - 1];
	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
			<div style={{
				width: size[0], height: size[1], borderRadius: 10, flexShrink: 0,
				background: color,
				display: 'flex', flexDirection: 'column',
				alignItems: 'center', justifyContent: 'center',
				boxShadow: `0 4px 10px ${color}66`,
			}}>
				<div style={{ color: '#fff', fontWeight: 800, fontSize, lineHeight: 1.1 }}>{parseInt(hari)}</div>
				<div style={{ color: 'rgba(255,255,255,0.88)', fontSize: 11, fontWeight: 600, lineHeight: 1.3 }}>{bulanName}</div>
			</div>
			<Text style={{ color: '#aaa', fontSize: 13 }}>{tahun}</Text>
		</div>
	);
}

class DataHariLibur extends React.Component {
	formModalRef = React.createRef();

	constructor(props) {
		super(props);
		const tahunIni = new Date().getFullYear();
		this.state = {
			errMsg    : '',
			errTitle  : '',
			loadingData: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile  : window.innerWidth <= 768,
			filterTahun: tahunIni,

			// modal
			modalVisible      : false,
			modalMode         : 'tambah', // 'tambah' | 'edit'
			modalEditId       : null,
			modalLoadingData  : false,
			modalLoadingSubmit: false,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	// ── Data list ───────────────────────────────────────────
	async getData(
		limit  = this.state.pagination.pageSize,
		offset = 0,
		search = this.state.searchText,
		tahun  = this.state.filterTahun,
	) {
		this.setState({ loadingData: true });
		let url = configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search;
		if (tahun) url += '&tahun=' + tahun;
		this.props.ajaxViewHandler('get', url)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val, this.state.filterTahun);
		}, 400);
	}

	handleFilterTahunChange = (val) => {
		this.setState(
			prev => ({ filterTahun: val || null, pagination: { ...prev.pagination, current: 1 } }),
			() => this.getData(this.state.pagination.pageSize, 0, this.state.searchText, val || null)
		);
	}

	handleTableChange = (pagination) => {
		this.setState({ pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current } });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize, this.state.searchText, this.state.filterTahun);
	}

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize, this.state.searchText, this.state.filterTahun);
	}

	// ── Delete ──────────────────────────────────────────────
	showDeleteConfirm(id) {
		Modal.confirm({
			title  : 'Konfirmasi Hapus',
			icon   : <ExclamationCircleOutlined />,
			content: 'Yakin ingin menghapus data hari libur ini?',
			okText : 'Hapus',
			okType : 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data hari libur berhasil dihapus', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal menghapus data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal hapus', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' }));
	}

	// ── Modal ───────────────────────────────────────────────
	openAddModal = () => {
		this.setState({ modalVisible: true, modalMode: 'tambah', modalEditId: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	openEditModal = (id) => {
		this.setState({ modalVisible: true, modalMode: 'edit', modalEditId: id, modalLoadingData: true });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();

		this.props.ajaxViewHandler('get', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					const d = this.props.responseMsg;
					this.setState({ modalLoadingData: false }, () => {
						if (this.formModalRef.current) {
							this.formModalRef.current.setFieldsValue({
								nama   : d.nama,
								tanggal: d.tanggal ? moment(d.tanggal, 'YYYY-MM-DD') : null,
							});
						}
					});
				} else {
					this.setState({ modalLoadingData: false });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ modalLoadingData: false });
				message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
			});
	}

	closeModal = () => {
		if (this.state.modalLoadingSubmit) return;
		this.setState({ modalVisible: false, modalEditId: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	handleModalSubmit = (values) => {
		const { modalMode, modalEditId } = this.state;
		const payload = {
			nama   : values.nama,
			tanggal: values.tanggal ? values.tanggal.format('DD-MM-YYYY') : null,
		};
		const method = modalMode === 'edit' ? 'put' : 'post';
		const url    = modalMode === 'edit'
			? configClass.apiUrl.data + modalEditId + '/'
			: configClass.apiUrl.data;

		this.setState({ modalLoadingSubmit: true });
		message.loading({ content: 'Menyimpan...', key: 'toast' });

		this.props.ajaxHandler(method, url, payload, false, true)
			.then(() => {
				this.setState({ modalLoadingSubmit: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.closeModal();
					this.getData();
				} else {
					message.destroy();
					this.setState({ errTitle: 'Gagal simpan', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ modalLoadingSubmit: false });
				message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' });
			});
	}

	// ── Render modal ─────────────────────────────────────────
	renderModal() {
		const { modalVisible, modalMode, modalLoadingData, modalLoadingSubmit, isMobile } = this.state;
		const isEdit = modalMode === 'edit';

		const header = (
			<div style={{
				background  : 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)',
				borderRadius: isMobile ? 0 : '8px 8px 0 0',
				padding     : isMobile ? '14px 18px' : '20px 28px',
				display     : 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14,
			}}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
					<div style={{
						width: isMobile ? 36 : 44, height: isMobile ? 36 : 44, flexShrink: 0,
						borderRadius: 10, background: 'rgba(255,255,255,0.15)',
						display: 'flex', alignItems: 'center', justifyContent: 'center',
					}}>
						{isEdit
							? <EditOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} />
							: <PlusCircleOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} />
						}
					</div>
					<div>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>
							{isEdit ? 'Edit Hari Libur' : 'Tambah Hari Libur'}
						</div>
						{!isMobile && (
							<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
								{isEdit ? 'Ubah informasi hari libur' : 'Isi formulir untuk menambah hari libur baru'}
							</div>
						)}
					</div>
				</div>
				<Button
					type="text"
					icon={<CloseCircleOutlined style={{ fontSize: 18 }} />}
					onClick={this.closeModal}
					disabled={modalLoadingSubmit}
					style={{ color: 'rgba(255,255,255,0.8)', padding: 4 }}
				/>
			</div>
		);

		const formBody = (
			<div style={{ padding: isMobile ? '18px 16px 0' : '24px 28px 0' }}>
				{modalLoadingData ? (
					<div style={{ textAlign: 'center', padding: isMobile ? 36 : 52 }}>
						<Spin size="large" />
						<div style={{ marginTop: 12, color: '#888', fontSize: 13 }}>Memuat data...</div>
					</div>
				) : (
					<Form
						ref={this.formModalRef}
						layout="vertical"
						onFinish={this.handleModalSubmit}
					>
						<Form.Item
							label={<span><CalendarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Tanggal</span>}
							name="tanggal"
							rules={[{ required: true, message: 'Tanggal harus diisi' }]}
						>
							<DatePicker
								format="DD-MM-YYYY"
								placeholder="Pilih tanggal hari libur"
								style={{ width: '100%', borderRadius: 8 }}
								allowClear
							/>
						</Form.Item>

						<Form.Item
							label={<span><FileTextOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Hari Libur</span>}
							name="nama"
							rules={[{ required: true, message: 'Nama hari libur harus diisi' }]}
							style={{ marginBottom: 0 }}
						>
							<Input
								placeholder="Contoh: Hari Kemerdekaan RI, Lebaran, dst..."
								style={{ borderRadius: 8, height: 38 }}
							/>
						</Form.Item>
					</Form>
				)}
			</div>
		);

		const footer = !modalLoadingData && (
			<div>
				<Divider style={{ margin: '16px 0 0' }} />
				<div style={{
					padding       : isMobile ? '14px 16px' : '16px 28px',
					display       : 'flex',
					flexDirection : isMobile ? 'column-reverse' : 'row',
					justifyContent: isMobile ? 'stretch' : 'flex-end',
					gap           : 10,
					background    : '#fafafa',
					borderRadius  : isMobile ? 0 : '0 0 8px 8px',
				}}>
					<Button
						icon={<CloseCircleOutlined />}
						onClick={this.closeModal}
						disabled={modalLoadingSubmit}
						style={{ borderRadius: 8, height: 40, width: isMobile ? '100%' : 'auto' }}
					>
						Batal
					</Button>
					<Button
						type="primary"
						icon={<SaveOutlined />}
						loading={modalLoadingSubmit}
						onClick={() => this.formModalRef.current && this.formModalRef.current.submit()}
						style={{
							background  : 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							border      : 'none', borderRadius: 8, fontWeight: 600,
							height      : 40, width: isMobile ? '100%' : 'auto',
						}}
					>
						{isEdit ? 'Simpan Perubahan' : 'Tambah Hari Libur'}
					</Button>
				</div>
			</div>
		);

		return (
			<Modal
				visible={modalVisible}
				onCancel={this.closeModal}
				footer={null}
				title={null}
				closable={false}
				width={isMobile ? 'calc(100vw - 16px)' : 520}
				style={isMobile ? { top: 12, margin: '0 8px' } : { top: 60 }}
				bodyStyle={{ padding: 0 }}
				maskClosable={!modalLoadingSubmit}
				destroyOnClose
			>
				{header}
				{formBody}
				{footer}
			</Modal>
		);
	}

	// ── Table columns ────────────────────────────────────────
	_buildColumns() {
		return [
			{
				title : 'No',
				key   : 'no',
				width : 56,
				align : 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return <Text style={{ fontSize: 12, color: '#888' }}>{(pagination.current - 1) * pagination.pageSize + index + 1}</Text>;
				},
			},
			{
				title    : 'Tanggal',
				dataIndex: 'tanggal',
				key      : 'tanggal',
				width    : 160,
				render   : (val) => renderTanggalBadge(val),
			},
			{
				title    : 'Nama Hari Libur',
				dataIndex: 'nama',
				key      : 'nama',
				render   : (val) => <Text strong>{val || '—'}</Text>,
			},
			{
				title : 'Aksi',
				key   : 'aksi',
				width : 100,
				fixed : 'right',
				align : 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title="Edit">
							<Button size="small" shape="circle" type="primary" ghost onClick={() => this.openEditModal(row.id)}>
								<FormOutlined />
							</Button>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				),
			},
		];
	}

	// ── Mobile card ──────────────────────────────────────────
	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background  : 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding     : '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					{renderTanggalBadge(row.tanggal, 16, [44, 48])}
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847', lineHeight: 1.3 }}>
							{row.nama || '—'}
						</div>
					</div>
					<div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
						<Button size="middle" shape="circle" type="primary" ghost onClick={() => this.openEditModal(row.id)}>
							<FormOutlined />
						</Button>
						<Button size="middle" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
							<CloseSquareOutlined />
						</Button>
					</div>
				</div>
			</Card>
		);
	}

	_buildTahunOptions() {
		const tahunIni = new Date().getFullYear();
		const options = [];
		for (let t = tahunIni + 1; t >= tahunIni - 5; t--) options.push(t);
		return options;
	}

	// ── Main render ──────────────────────────────────────────
	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText, filterTahun } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-hl-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-hl-wrap .ant-table-tbody > tr > td { padding: 12px 16px; vertical-align: middle; }
						.data-hl-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.data-hl-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.data-hl-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.data-hl-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 13px; }
						.data-hl-wrap .ant-picker { border-radius: 8px !important; }
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				{this.renderModal()}

				<Card
					className="data-hl-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding       : isMobile ? '14px 16px' : '16px 20px',
						background    : 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display       : 'flex', alignItems: 'center',
						justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 17 }}>
								<CalendarOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							{!isMobile && (
								<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
									Total {pagination.total || 0} hari libur terdaftar{loadingData && ' · Memuat...'}
								</div>
							)}
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh">
								<Button
									onClick={() => this.setState(
										prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
										() => this.getData(this.state.pagination.pageSize, 0, '', this.state.filterTahun)
									)}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Button
								type="primary"
								icon={<PlusOutlined />}
								onClick={this.openAddModal}
								style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
							>
								{isMobile ? 'Tambah' : 'Tambah Hari Libur'}
							</Button>
						</div>
					</div>

					{/* Filter tahun */}
					<div style={{
						padding: isMobile ? '10px 12px' : '12px 20px',
						borderBottom: '1px solid #eef2ff', background: '#f8faff',
						display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#1e4d8a', fontSize: 13, fontWeight: 600, flexShrink: 0 }}>
							<FilterOutlined />
							<span>Tahun:</span>
						</div>
						<Select
							value={filterTahun}
							onChange={this.handleFilterTahunChange}
							allowClear
							placeholder="Semua Tahun"
							style={{ minWidth: 110, borderRadius: 8 }}
						>
							{this._buildTahunOptions().map(t => (
								<Select.Option key={t} value={t}>{t}</Select.Option>
							))}
						</Select>
					</div>

					{/* Search bar */}
					<div style={{
						padding     : isMobile ? '10px 12px' : '12px 20px',
						borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari nama hari libur..."
							allowClear
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: isMobile ? '100%' : 340, width: isMobile ? '100%' : 'auto' }}
							value={searchText}
							onChange={this.handleSearchChange}
						/>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData
									? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
									: dataSource.length === 0
										? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
										: dataSource.map(row => this.renderMobileCard(row))
								}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize}
											total={pagination.total} onChange={this.handleMobilePageChange}
											showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current        : pagination.current,
									pageSize       : pagination.pageSize,
									total          : pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal      : (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(mapStateToProps, {
	initHandler, setConfig, ajaxViewHandler, ajaxHandler,
})(DataHariLibur);
